import { render, staticRenderFns } from "./ParapharmacyTemplateSelectorNetworkError.vue?vue&type=template&id=6baf12e3"
import script from "./ParapharmacyTemplateSelectorNetworkError.vue?vue&type=script&lang=js"
export * from "./ParapharmacyTemplateSelectorNetworkError.vue?vue&type=script&lang=js"
import style0 from "./ParapharmacyTemplateSelectorNetworkError.vue?vue&type=style&index=0&id=6baf12e3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports